import ImportMappingProfilesTable from "./components/ImportMappingProfilesTable.jsx";

export default function ImportMappingProfilePage() {
  return <ImportMappingProfilesTable />;
}
